import {BASE_URL} from '../constants/SystemConstants';

export const PERSON_URL= BASE_URL + 'people';